import './casino888-fonts';
import {OrbitTheme} from '../../architecture/orbit-theme.interface';
import {makeTheme} from '../../make-theme';
import {IGeneralColors} from '../../architecture/sections/general-colors.interface';
import {Casino888Icons} from './icons-registry';
import { ThemeName } from '../../architecture/theme-names';
import {createGlobalStyle} from "styled-components";
import React from "react";
import {baseColors} from "./base-colors";
import {IThemeDefinition} from "../../../services/theme/theme-definition.interface";
import {ThemeBoxes} from "./theme.boxes";
import {makeCommonGlobalStyles} from "../../global-styles/common-global-styles";
import {IThemeInitializationParams} from "../../architecture/theme-initialization-params";

const GlobalStyles = createGlobalStyle`
    ${makeCommonGlobalStyles()}
    body {
        font-family: "888-Orbit", verdana, sans-serif;
        font-weight: 600;
    }
`;



const generalColors: IGeneralColors  = {
    brandPrimary: baseColors.base01,
    brandPrimaryDark: baseColors.base01Dark,
    brandPrimaryLight: baseColors.base01Light,
    brandPrimaryContrast: baseColors.base01Contrast,

    brandSecondary: baseColors.base02,
    brandSecondaryDark: baseColors.base02Dark,
    brandSecondaryLight: baseColors.base02Light,
    brandSecondaryContrast: baseColors.base02Contrast,

    backgroundDark: baseColors.black,
    backgroundMiddleDark: baseColors.gray023,
    background: baseColors.gray033, //bodyBackground
    backgroundLight: baseColors.gray043, //bodyBackgroundLight
    backgroundHover: baseColors.gray033,
    backgroundActive: baseColors.gray033,
    backgroundContrast: baseColors.white,
    iconBackgroundActive: baseColors.base01,
    logoBackground: baseColors.base01,

    textDark: baseColors.black,
    textMiddleDark: baseColors.gray113,
    text: baseColors.gray183,
    textLight: baseColors.white, //bodyText
    textHover: baseColors.white,
    textActive: baseColors.base01,
    textContrast: baseColors.white,
    moneyColor: baseColors.base02,

    boxBorderDark: baseColors.black,
    boxBorderMediumDark: baseColors.gray023,
    boxBorder: baseColors.gray033,
    boxBorderLight: baseColors.gray043,
    boxBorderLighter: baseColors.gray053,
    boxBorderContrast: baseColors.gray113, //bodyInfo
    modalDialogBorder: baseColors.gray113,

    danger: baseColors.base03,
    dangerDark: baseColors.base03Dark,
    dangerLight: baseColors.base03Light,

    buttonDark: baseColors.black,
    buttonLight: baseColors.white,
    buttonInfo: baseColors.gray113,
    buttonWarning: baseColors.base03,

    horizontalLineBackgroundColor: baseColors.gray033,
    horizontalLineBackgroundImage: "",

    gameModeRealBackground: baseColors.gray023,
    gameModeDemoBackground: baseColors.white,

    sportBrandPrimary: "#FC6200",
    pokerBrandPrimary: "#0370DD",
    videoSlidesFilterButtonOutline: baseColors.gray193,

    snackbarNotificationBg: baseColors.gray043,
    exploreHighlight: baseColors.explorePurple,

};


export default (params: IThemeInitializationParams): IThemeDefinition => {
    const Casino888Theme: OrbitTheme = makeTheme({
        assetsMap: params.assetsMap,
        generalColors: generalColors,
        themeSpecificIcons: Casino888Icons
    });

    Casino888Theme.globalStyles = (<GlobalStyles/>);

    const themeDefinition: IThemeDefinition = {
        themeName: ThemeName.Casino888,
        shellTheme: Casino888Theme,
        mainContentTheme: Casino888Theme,
        popupsTheme: Casino888Theme,
        toastersTheme: Casino888Theme,
        themeBoxes: ThemeBoxes
    }

    return themeDefinition;
}